import { render, staticRenderFns } from "./EditUserModal.vue?vue&type=template&id=1588b644"
import script from "./EditUserModal.vue?vue&type=script&lang=ts"
export * from "./EditUserModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports